import React, { useState } from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import { IconCheckmarkStrongM } from '../../../icons';
import { Alert, Button, Form, IconSpinner } from '../../../components';
import css from './PicCardForm.css';

const radioButtonProps = {
    component: 'input',
    name: 'pic',
    type: 'radio',
    maxLength: 1,
};

export const getPicBlob = async src => {
    try {
        const response = await fetch(src);
        const picBlob = await response.blob();

        return picBlob;
    } catch (e) {
        return null;
    }
};

const PicCard = ({ pic, index, src, applySelectedOverlay = true, inputProps = {} }) => {
    const inputFieldAttr = { ...radioButtonProps, ...inputProps };
    const maxLength = inputFieldAttr.maxLength;

    const isMultiple = inputFieldAttr.type === 'checkbox';

    const notEmpty = !!pic;
    const isSelected = isMultiple ? (pic || []).includes(src) : src === pic;
    const maxNumReachedForSingle = !isMultiple && notEmpty;
    const maxNumReachedForMulti = isMultiple && Array.isArray(pic) && pic.length === maxLength;
    const maxNumReached = !isSelected && (maxNumReachedForMulti || maxNumReachedForSingle);
    const disabledForMulti = isMultiple && !isSelected && maxNumReached;
    const disabled = disabledForMulti;

    return (
        <div
            className={classNames(css.field, {
                [css.selected]: isSelected,
                [css.maxNumReached]: maxNumReached,
                // [css.multiSelected]:  isSelected,
            })}
        >
            <Field {...inputFieldAttr} id={index} value={src} disabled={disabled} />
            <label
                htmlFor={index}
                className={css.label}
                style={{ backgroundImage: `url(${src})` }}
            />

            <div className={css.pseoudoInput}>{isSelected ? <IconCheckmarkStrongM /> : null}</div>
            <div className={css.maxNumReachedOverlay} />
            {applySelectedOverlay && <div className={css.selectedOverlay} />}
        </div>
    );
};

export default ({
    formClassName,
    pic,
    heading,
    error,
    loading,
    images,
    onBlobRequest = () => null,
    children,
    isMultiple,
    inputProps = {},
    applySelectedOverlay,
}) => {
    const [requested, setRequested] = useState(false);

    const handlePicSelect = async () => {
        if (loading || requested) return;

        setRequested(true);

        try {
            if (isMultiple) {
                const blobs = await Promise.all(pic.map(async p => await getPicBlob(p)));
                onBlobRequest(blobs);
            } else {
                const blob = await getPicBlob(pic);
                onBlobRequest(blob);
            }
        } catch (e) {
        } finally {
            setRequested(false);
        }
    };
    return (
        <Form
            onSubmit={() => null}
            className={classNames(css.form, {
                [formClassName]: !!formClassName,
            })}
        >
            <h3>{heading}</h3>
            {error && (
                <Alert
                    showAsPlainText
                    type="failure"
                    description={error}
                    closeAllowed={false}
                    rootClassName={css.alertRoot}
                />
            )}
            {loading && <IconSpinner />}
            {children}
            <div className={css.root}>
                {Array.isArray(images) &&
                    images.map((src, i) => (
                        <PicCard
                            key={i}
                            index={i}
                            pic={pic}
                            src={src}
                            inputProps={
                                isMultiple ? { type: 'checkbox', ...inputProps } : { ...inputProps }
                            }
                            applySelectedOverlay={applySelectedOverlay}
                        />
                    ))}
            </div>
            {!loading && (
                <footer>
                    <Button
                        disabled={!pic}
                        className={css.actionButton}
                        type="button"
                        onClick={handlePicSelect}
                    >
                        Auswählen
                    </Button>
                </footer>
            )}
        </Form>
    );
};
